var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarouselImage2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 191,
    viewBox: "0 0 186 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.618 14.4174C135.164 24.4537 150.109 46.3417 150.109 71.7233C150.109 93.5312 139.077 112.74 122.329 124.09H122.308L105.854 160.641H68.3033L51.8493 124.09L51.8338 124.069C35.0649 112.724 24.0518 93.5105 24.0518 71.7233C24.0518 36.8407 52.2751 8.56259 87.0904 8.56259C96.5653 8.56259 105.552 10.6599 113.618 14.4174Z",
    fill: "#FFB81C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.183 108.624C124.794 112.361 120.964 115.689 116.777 118.528H116.759L100.305 155.076H62.7515L46.2975 118.528L46.2794 118.51C29.5106 107.16 18.5 87.9511 18.5 66.1614C18.5 31.2787 46.7233 3.00077 81.5361 3.00077C91.011 3.00077 100.001 5.09794 108.066 8.85541",
    stroke: "white",
    strokeWidth: 5.17201,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.775 118.526V118.508",
    stroke: "white",
    strokeWidth: 5.17201,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105.324 155.075H57.7329V182.919H105.324V155.075Z",
    stroke: "white",
    strokeWidth: 5.17201,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1074 182.92C62.1074 182.92 62.2338 194.001 81.5269 194.001C100.825 194.001 100.567 182.92 100.567 182.92",
    stroke: "white",
    strokeWidth: 5.17201,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.324 162.557L57.7329 175.058",
    stroke: "white",
    strokeWidth: 5.17201,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4991 155.076L56.7485 87.8942",
    stroke: "white",
    strokeWidth: 5.17201,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92.252 155.076L100.568 110.062",
    stroke: "white",
    strokeWidth: 5.17201,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4623 81.7383C29.3367 71.2417 29.711 59.7339 33.5128 49.4675C37.3172 39.1984 44.5234 30.2301 53.7222 24.3159",
    stroke: "white",
    strokeWidth: 5.17201,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8892 17.958C68.9454 16.0883 74.3397 15.1392 79.7289 15.1677",
    stroke: "white",
    strokeWidth: 5.17201,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M137.618 74.5788C126.329 74.5788 117.184 65.419 117.184 54.1259C117.184 42.8328 126.329 33.6706 137.618 33.6706C148.89 33.6706 158.032 42.8328 158.032 54.1259C158.032 65.419 148.89 74.5788 137.618 74.5788ZM179.761 69.4971C181.555 64.5837 182.463 59.3341 182.499 54.1259C182.463 48.9151 181.555 43.6863 179.761 38.7522L169.285 42.5717C167.935 38.8453 165.937 35.4136 163.418 32.4293L171.987 25.2144C165.305 17.1848 155.701 11.6585 145.392 9.86123L143.467 20.875C141.559 20.5233 139.616 20.3578 137.618 20.3578C135.621 20.3578 133.656 20.5233 131.749 20.875L129.826 9.86123C124.68 10.7689 119.703 12.5869 115.169 15.2013C110.652 17.8158 106.564 21.1906 103.231 25.2144L111.8 32.4293C109.281 35.4136 107.284 38.8452 105.949 42.5898L95.4574 38.7522C93.6636 43.6863 92.755 48.9151 92.7163 54.1259C92.755 59.3341 93.6636 64.5837 95.4574 69.4971L105.949 65.6776C107.302 69.404 109.281 72.8357 111.8 75.82L103.231 83.0349C106.564 87.0588 110.652 90.4336 115.169 93.048C119.703 95.6625 124.68 97.4803 129.826 98.3906L131.749 87.3743C133.656 87.726 135.621 87.8941 137.618 87.8941C139.616 87.8941 141.559 87.726 143.467 87.3743L145.392 98.3906C155.701 96.5908 165.305 91.0645 171.987 83.0349L163.436 75.8407C165.937 72.8539 167.935 69.4221 169.285 65.6776L179.761 69.4971Z",
    stroke: "white",
    strokeWidth: 5.17201,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselImage2);
export default __webpack_public_path__ + "static/media/CarouselImage2.d8caa1326ffff93227b9620bbbdd4083.svg";
export { ForwardRef as ReactComponent };